function Section({ children, background = "bg-gray-100 dark:bg-[#010128]" }) {
  return (
    <section className={`${background} py-12`}>
      {" "}
      <div className="container mx-auto px-4">{children}</div>{" "}
    </section>
  );
}
export default Section;
